<template>
  <div class="family-success tongxin-layout">
    <div class="success-content">
      <!-- 成功圖標 -->
      <div class="success-icon">
        <svg viewBox="0 0 52 52" class="checkmark">
          <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
          <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
        </svg>
      </div>

      <!-- 成功訊息 -->
      <h1 class="success-title">{{ successTitle }}</h1>
      <!-- <p class="success-message">{{ successMessage }}</p> -->

      <!-- 按鈕 -->
      <div class="button-group">
        <button class="btn btn-primary w-100 mb-3" @click="goToFamilyList">
          回家庭成員頁
        </button>

        <button class="btn btn-secondary w-100" @click="goToLineOA">
          回 LINE 對話框
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TongxinFamilySuccess',
  computed: {
    action() {
      return this.$route.query.action || 'add'
    },

    successTitle() {
      switch (this.action) {
        case 'add':
          return '新增親友成功'
        case 'edit':
          return '更新親友資料成功'
        case 'delete':
          return '刪除親友成功'
        default:
          return '操作成功'
      }
    },

    successMessage() {
      switch (this.action) {
        case 'add':
          return '已成功新增家庭成員資料'
        case 'edit':
          return '已成功更新家庭成員資料'
        case 'delete':
          return '已成功刪除家庭成員資料'
        default:
          return '操作已完成'
      }
    },
  },
  methods: {
    goToFamilyList() {
      this.$router.push({ name: 'TongxinFamilyList' })
    },

    goToLineOfficialAccount() {
      const orgCode = this.$route.params.orgCode || this.$route.params.org_code

      if (orgCode) {
        window.location.href = `${process.env.VUE_APP_API_BASE_URL}/${orgCode}/liff/general/redirect-to-oa`
        return
      }

      if (window.liff && typeof window.liff.closeWindow === 'function') {
        window.liff.closeWindow()
      }
    },

    goToLineOA() {
      this.goToLineOfficialAccount()
    },
  },
}
</script>

<style lang="scss" scoped>
.family-success {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;

  .success-content {
    text-align: center;
    width: 100%;

    .success-icon {
      margin: 0 auto 32px;
      width: 100px;
      height: 100px;

      .checkmark {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        display: block;
        stroke-width: 3;
        stroke: #207868;
        stroke-miterlimit: 10;
        box-shadow: inset 0px 0px 0px #207868;
        animation: scale 0.3s ease-in-out 0.9s both;

        .checkmark-circle {
          stroke-dasharray: 166;
          stroke-dashoffset: 166;
          stroke-width: 3;
          stroke-miterlimit: 10;
          stroke: #207868;
          fill: none;
          animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
        }

        .checkmark-check {
          transform-origin: 50% 50%;
          stroke-dasharray: 48;
          stroke-dashoffset: 48;
          animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
        }
      }
    }

    .success-title {
      font-size: 28px;
      font-weight: bold;
      color: #207868;
      margin-bottom: 16px;
    }

    .success-message {
      font-size: 16px;
      color: #666;
      margin-bottom: 48px;
    }

    .button-group {
      margin-top: 40px;

      .btn {
        padding: 14px 24px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 8px;
        transition: all 0.3s;

        &.btn-primary {
          background: #207868;
          border: none;
          color: white;

          &:hover {
            background: #186052;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(32, 120, 104, 0.2);
          }
        }

        &.btn-secondary {
          background: #6c757d;
          border: none;
          color: white;

          &:hover {
            background: #5a6268;
          }
        }
      }
    }
  }
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes scale {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}

</style>
